import React from 'react';
import { createColumnHelper } from '@tanstack/react-table';
import I18n from 'i18n-js';
import {
  IHolisticRubricDescription,
} from '../../useQuestionRubric';

type HolisticRubricColumnSizes = {
  description?: string;
  score?: string;
};

type CreateHolisticRubricColumnsArgs = {
  DescriptionCell: React.ComponentType<any>;
  cellProps?: Record<string, any>;
  locale?: Lowercase<Locale>;
  columnSizes?: HolisticRubricColumnSizes;
};

export const createHolisticRubricColumns = ({
  DescriptionCell,
  cellProps,
  locale,
  columnSizes = {
    score: '200px',
    description: 'auto',
  },
}:
CreateHolisticRubricColumnsArgs) => {
  const columnHelper = createColumnHelper<IHolisticRubricDescription>();
  const scoreSize = columnSizes.score;
  const descriptionSize = columnSizes.description;

  return [
    columnHelper.accessor('score', {
      cell: info => info.getValue(),
      header: I18n.t('score'),
      meta: { width: scoreSize },
    }),
    columnHelper.accessor(locale === 'en' ? 'description_en' : 'description_es', {
      cell: info => <DescriptionCell data={info.row.original} locale={locale} {...cellProps} />,
      header: I18n.t('description'),
      meta: { width: descriptionSize },
    }),
  ];
};
